import { Injectable } from '@angular/core';

@Injectable()
export class LoadingService {
	private __loadingContent:boolean = false;

	private __loadingCount:number = 0;

	get loadingContent():boolean {
        return !!this.__loadingCount;
    }
    set loadingContent(show:boolean) {
    	this.__loadingCount += (show ? 1 : -1 );
    }
}


// WEBPACK FOOTER //
// ./src/services/loading.service.ts